import type { FaireProductEntity } from "../../entity_types/product";

export const p_78fuujjdd3: FaireProductEntity = {
  token: "p_78fuujjdd3",
  type: "product",
  name: "Women's Slouchy Fuzzy Socks with Non-Slip Grippers",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/84a8aaec0551d344071750b8baa03fd419ad5e7f36b81f7430abc6f42477c8d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cccc506900b2408ef5b2c2c9b715c0e22a49c496e372f49772879655e510dd4b.jpeg",
    "https://cdn.faire.com/fastly/bed30d22e66c8056be0ea58741ea6081a5876bf54c12c1c2edef5081a8985143.jpeg",
    "https://cdn.faire.com/fastly/782fea029367ea4e59fac36aa58ab3ec97e1c3656005416ca7a6bfce2dd4c682.jpeg",
    "https://cdn.faire.com/fastly/20fc59dd46b618896541c3848ab6adcea1a31b3de4060734c4a41badfea4ebc8.jpeg",
    "https://cdn.faire.com/fastly/3fae1e55d992c73276abe896ab100831cf03b5cab7c64db4659619a61b3a3c63.jpeg",
    "https://cdn.faire.com/fastly/ac563ed17d27e94769d28f5798726f19f13cb86770f6cb31a8703bb7a49146ac.jpeg",
    "https://cdn.faire.com/fastly/855628bbce6febc4b152cd5eb837017e803c20e56a22b378253dd24b5c6ab97c.jpeg",
    "https://cdn.faire.com/fastly/861b7819660a6dcdf88947b74cadbf013701d562479edb92dd12575fedbf7453.jpeg",
    "https://cdn.faire.com/fastly/dae3bc674ff3e7320aeb11cc77e351c2b7476d892d01f83fbbc3a034d38e5570.jpeg",
    "https://cdn.faire.com/fastly/564a845ec484e35ee2d24cf27bd0939f348be80fc19313ef15239d7a6bda7844.jpeg",
    "https://cdn.faire.com/fastly/a3bf9d162387d975b5e97a739e36dbbd0b15379f38f0fb3bf14dbd327d6585ac.jpeg",
    "https://cdn.faire.com/fastly/f0858213224d334bef7387004845739932f43c99112b46729b6701bd4f3b74e4.jpeg",
    "https://cdn.faire.com/fastly/8e657a6120b31c981840520783a41b7b911d9b87d007e73a5ceeccf84b076803.jpeg"
  ],
  priceDollars: 11,
  description: "Escape into pure bliss with our plush slouch socks.\nExperience unrivaled comfort as you sink your feet into their opulent softness. Enhanced with non-slip grippers, these socks offer improved mobility without compromising safety. Our Marshmallow Slouch Socks provide a sensory treat that will leave you craving more. Relax and let the tension melt away as these socks envelop you in sumptuous softness. Treat your feet to lavish comfort; they deserve it.\n\n𝐒𝐥𝐨𝐮𝐜𝐡 𝐒𝐨𝐜𝐤𝐬 𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Plush and extra comfy\n• Non-slip grippers on the bottom\n• One-size-fits-most, these slouch socks are the perfect match for every sole.\n• Available in multiple colors, heathered or solid\n• Perfect Gift Idea\n\n𝐒𝐥𝐨𝐮𝐜𝐡 𝐒𝐨𝐜𝐤𝐬 𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥 & 𝐂𝐚𝐫𝐞\n• Easy-care Marshmallow fabric, a durable blend of 51% polyester and 49% nylon\n• Machine Wash Cold, Tumble Dry, Low.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:46:58.355Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
